import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export function ImageSlot({ label, kind, fileId, isAdmin, onChange, hint }) {
  const ref = useRef(null);
  const [v, setV] = useState(0);
  const upload = async (e) => {
    const file = e.target.files?.[0]; e.target.value = "";
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post(`/settings/image/${kind}`, fd); onChange(data); setV((x) => x + 1); toast.success(`${label} saved`); }
    catch (err) { toast.error(err?.response?.data?.detail || "Upload failed (PNG/JPG only)"); }
  };
  const remove = async () => {
    try { const { data } = await api.delete(`/settings/image/${kind}`); onChange({ ...data, [`${kind}_file_id`]: undefined }); toast.success(`${label} removed`); }
    catch { toast.error("Failed to remove"); }
  };
  return (
    <div className="rounded-md border border-slate-200 p-2.5 space-y-2" data-testid={`image-slot-${kind}`}>
      <div className="flex items-center justify-between"><span className="text-xs font-medium text-slate-700">{label}</span>
        {fileId && isAdmin && <button type="button" onClick={remove} className="text-slate-400 hover:text-rose-600" title="Remove" data-testid={`image-remove-${kind}`}><X className="h-3.5 w-3.5" /></button>}
      </div>
      <div className="h-20 rounded border border-dashed border-slate-300 bg-slate-50 flex items-center justify-center overflow-hidden">
        {fileId ? <img key={v} src={`${api.defaults.baseURL}/files/${fileId}?v=${v}`} alt={label} className="max-h-16 max-w-full object-contain" data-testid={`image-preview-${kind}`} /> : <span className="text-[11px] text-slate-400">{hint || "None uploaded"}</span>}
      </div>
      {isAdmin && (
        <>
          <input ref={ref} type="file" accept="image/png,image/jpeg" className="hidden" onChange={upload} data-testid={`image-input-${kind}`} />
          <Button type="button" variant="outline" size="sm" className="w-full h-8 text-xs" onClick={() => ref.current?.click()} data-testid={`image-upload-${kind}`}><Upload className="h-3.5 w-3.5 mr-1.5" />{fileId ? "Replace" : "Upload"} PNG/JPG</Button>
        </>
      )}
    </div>
  );
}
